module.exports = __webpack_public_path__ + "static/owolabi-33609e5c5756581817912bff902788d5.png";